var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoesHeelheight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feature_03",
    transform: "translate(-170 -1316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8427",
    "data-name": "\\uC0AC\\uAC01\\uD615 8427",
    width: 50,
    height: 50,
    transform: "translate(170 1316)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20498",
    "data-name": "\\uADF8\\uB8F9 20498",
    transform: "translate(0.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20399",
    "data-name": "\\uADF8\\uB8F9 20399",
    transform: "translate(-7846.083 809.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_8387",
    "data-name": "\\uC0AC\\uAC01\\uD615 8387",
    d: "M0,0H22.817a0,0,0,0,1,0,0V5a0,0,0,0,1,0,0H3A3,3,0,0,1,0,2V0A0,0,0,0,1,0,0Z",
    transform: "translate(8018 536)",
    fill: "#ef6156"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20397",
    "data-name": "\\uADF8\\uB8F9 20397",
    transform: "translate(3741 1387.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2430",
    "data-name": "\\uD328\\uC2A4 2430",
    d: "M17.584,7.127a29.12,29.12,0,0,0,15.541,7.319c8.857,1.082,11.8,4.386,13.015,7.517,0,0,.762,1.588.5,5.477a2.034,2.034,0,0,1-1.963,1.775H4.59a2.14,2.14,0,0,1-2.1-2.19C2.427,25.757.733,16.946,4.026,11.935,4.026,11.935,12.159,14.116,17.584,7.127Z",
    transform: "translate(4275.47 -875.203)",
    fill: "none",
    stroke: "#040405",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2431",
    "data-name": "\\uD328\\uC2A4 2431",
    d: "M19.405,9.456,17.719,6.179l5.144-3.536s2,2.225,2.577,2.65",
    transform: "translate(4267.941 -873.055)",
    fill: "none",
    stroke: "#040405",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_2",
    "data-name": "\\uC120 2",
    x2: 43.729,
    transform: "translate(4278.118 -851.396)",
    fill: "none",
    stroke: "#040405",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2432",
    "data-name": "\\uD328\\uC2A4 2432",
    d: "M9.83,32.8a6.892,6.892,0,0,0-7.044-6.9",
    transform: "translate(4275.094 -884.191)",
    fill: "none",
    stroke: "#040405",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2433",
    "data-name": "\\uD328\\uC2A4 2433",
    d: "M67.332,25.611s-.188,3.4-4.38,3.291-5.271.592-5.982,1.535A6.814,6.814,0,0,0,56.1,32.66",
    transform: "translate(4249.511 -884.056)",
    fill: "none",
    stroke: "#040405",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_4",
    "data-name": "\\uC120 4",
    x1: 2.664,
    y2: 3.547,
    transform: "translate(4295.624 -863.599)",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_5",
    "data-name": "\\uC120 5",
    x1: 2.664,
    y2: 3.547,
    transform: "translate(4301.264 -861.147)",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoesHeelheight);
export default __webpack_public_path__ + "static/media/shoes_heelheight.6b06fb332a2c988ca9115d8ccc977fdb.svg";
export { ForwardRef as ReactComponent };